// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"952192bc","977":"c9f58207"}[chunkId] + ".chunk.js";
};